export enum TokenStatus {
  TOO_MANY_REQUEST = 429,
  INVALID_LINK = 404,
  LINK_EXPIRE = 423
}
